var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"obj-button obj-button--primary mdl-dealer-search__submit-btn",class:{ 'obj-button--loading': _vm.loading },attrs:{"type":_vm.type}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }